import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from '@app/sharedModule/shared.module';
import { StorybookModule } from '@app/storybook/storybook.module';
import { ProductPageComponent } from './product-page/product-page.component';
import { PromiseAIComponent } from './promise-ai/promise-ai.component';
import { ProductPageConditionsComponent } from './product-page/components/product-page-conditions/product-page-conditions.component';
import { ProductPageSettingsTabComponent } from './product-page/components/product-page-settings-tab/product-page-settings-tab.component';
import { ProductPageConfigurationsBasicTabComponent } from './product-page/components/product-page-configurations-basic-tab/product-page-configurations-basic-tab.component';
import { ProductPageConfigurationsAdvancedTabComponent } from './product-page/components/product-page-configurations-advanced-tab/product-page-configurations-advanced-tab.component';
import { ProductPageDisplayConditionsTabComponent } from './product-page/components/product-page-display-conditions-tab/product-page-display-conditions-tab.component';
import { LabelComponentEditorComponent } from './product-page/components/label-component-editor/label-component-editor.component';
import { DeliveryDateComponentEditorComponent } from './product-page/components/delivery-date-component-editor/delivery-date-component-editor.component';
import { ShippingMethodLineComponentEditorComponent } from './product-page/components/shipping-method-line-component-editor/shipping-method-line-component-editor.component';
import { LocationInputComponentEditorComponent } from './product-page/components/location-input-component-editor/location-input-component-editor.component';
import { CutoffTimerComponentEditorComponent } from './product-page/components/cutoff-timer-component-editor/cutoff-timer-component-editor.component';
import { TrustSignalsComponentEditorComponent } from './product-page/components/trust-signals-component-editor/trust-signals-component-editor.component';
import { FallbackAddressInputComponent } from './product-page/components/fallback-address-input/fallback-address-input.component';
import { PluginPreviewBasicComponent } from './product-page/plugin-preview-basic/plugin-preview-basic.component';
import { PluginPreviewAdvancedComponent } from './product-page/plugin-preview-advanced/plugin-preview-advanced.component';
import { PluginPreviewChromeComponent } from './product-page/plugin-preview-chrome/plugin-preview-chrome.component';
import { LabelComponentPreviewComponent } from './product-page/plugin-preview-advanced/component-previews/label-component-preview/label-component-preview.component';
import { DeliveryDateComponentPreviewComponent } from './product-page/plugin-preview-advanced/component-previews/delivery-date-component-preview/delivery-date-component-preview.component';
import { ShippingMethodLineComponentPreviewComponent } from './product-page/plugin-preview-advanced/component-previews/shipping-method-line-component-preview/shipping-method-line-component-preview.component';
import { LocationInputComponentPreviewComponent } from './product-page/plugin-preview-advanced/component-previews/location-input-component-preview/location-input-component-preview.component';
import { LineSeparatorComponentPreviewComponent } from './product-page/plugin-preview-advanced/component-previews/line-separator-component-preview/line-separator-component-preview.component';
import { CutoffTimerComponentPreviewComponent } from './product-page/plugin-preview-advanced/component-previews/cutoff-timer-component-preview/cutoff-timer-component-preview.component';
import { TrustSignalsComponentPreviewComponent } from './product-page/plugin-preview-advanced/component-previews/trust-signals-component-preview/trust-signals-component-preview.component';
import { PromiseAIPreviewComponent } from './promise-ai/components/preview/promise-ai-preview.component';
import { DisableSaveButtonPipe, ShippingTextPattern } from './product-page/pipes/product-promise-pipes';
import { ProductPromiseListComponent } from './product-page/product-promise-list/product-promise-list.component';
import { SmartCartModule } from './smart-cart/smart-cart.module';

@NgModule({
  declarations: [
    ProductPageComponent,
    PromiseAIComponent,
    ProductPageConditionsComponent,
    ProductPageSettingsTabComponent,
    ProductPageConfigurationsBasicTabComponent,
    ProductPageConfigurationsAdvancedTabComponent,
    ProductPageDisplayConditionsTabComponent,
    LabelComponentEditorComponent,
    DeliveryDateComponentEditorComponent,
    ShippingMethodLineComponentEditorComponent,
    LocationInputComponentEditorComponent,
    CutoffTimerComponentEditorComponent,
    TrustSignalsComponentEditorComponent,
    FallbackAddressInputComponent,
    PluginPreviewBasicComponent,
    PluginPreviewAdvancedComponent,
    PluginPreviewChromeComponent,
    LabelComponentPreviewComponent,
    DeliveryDateComponentPreviewComponent,
    ShippingMethodLineComponentPreviewComponent,
    LocationInputComponentPreviewComponent,
    LineSeparatorComponentPreviewComponent,
    CutoffTimerComponentPreviewComponent,
    TrustSignalsComponentPreviewComponent,
    PromiseAIPreviewComponent,
    DisableSaveButtonPipe,
    ShippingTextPattern,
    ProductPromiseListComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StorybookModule,
    SharedModule,
    MatDividerModule,
    MatSlideToggleModule,
    MatDialogModule,
    SmartCartModule,
  ],
  exports: [ProductPageComponent, PromiseAIComponent, SmartCartModule],
})
export class EngageModule {}
